import { AdditionalProfileDetails } from "@models/clients/clients.details/additionalProfileDetails";

class NewAdditionalProfileController {
  public additionalProfile: AdditionalProfileDetails;
  public client: any;
  public dropdownOptions: any = {};
  public isLoading: boolean = false;
  public isEditMode: boolean = false;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService
  ) {}

  $onInit() {
    // Initialize the additional profile object - create a copy to avoid modifying the original
    if (this.additionalProfile) {
      this.additionalProfile = { ...this.additionalProfile }; // Create a shallow copy
      this.isEditMode = this.additionalProfile.id > 0;
    } else {
      this.additionalProfile = {
        id: 0,
        name: '',
        typeOfPortfolio: 0,
        employmentStatus: 0,
        professionalActivity: 0,
        organisation: '',
        dateJoined: null,
        addressOfOrganisation: '',
        residentialAddress: '',
        comments: '',
        dateOfBirth: null,
        residencePhone: '',
        mobilePhone: '',
        businessPhoneNumber: '',
        emailAddress1: '',
        emailAddress2: '',
        emailAddress3: '',
        website: '',
        jurisdiction: 0,
        geographicalLocation: 0,
        geographicalLocationName: '',
        jurisdictionName: '',
        professionalActivityName: '',
        employmentStatusName: '',
        typeOfPortfolioName: '',
        linkedInUrl: '',
        emergencyFullName: '',
        emergencyEmailAddress: '',
        emergencyTypeOfRelatedParty: 0,
        emergencyBusinessPhone: '',
        emergencyResidentialAddress: '',
        emergencyResidencePhone: '',
        emergencyMobilePhone: '',
        emergencyOfficeAddress: ''
      };
      this.isEditMode = false;
    }
  }

  public saveAdditionalProfile() {
    this.$mdDialog.hide(this.additionalProfile);
  }

  public cancel() {
    this.$mdDialog.hide();
  }
}

export const newAdditionalProfileModal: angular.IComponentOptions = {
  template: require('./new-additional-profile.modal.html'),
  controller: NewAdditionalProfileController,
  controllerAs: '$ctrl',
  bindings: {
    additionalProfile: '<',
    client: '<',
    dropdownOptions: '<'
  }
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/profile/modals/new-additional-profile.modal.ts